import G6Wrapper from 'dashboard/components/GraphCanvasV2/G6Wrapper';
import ActionBarLayer from 'dashboard/components/GraphCanvasV2/layers/action-bar-layer';
import CanvasEdgeLayer from 'dashboard/components/GraphCanvasV2/layers/canvas-edge-layer';
import CanvasLayer from 'dashboard/components/GraphCanvasV2/layers/canvas-layer';
import CanvasNodeLayer from 'dashboard/components/GraphCanvasV2/layers/canvas-node-layer';
import DisplayPanelLayer from 'dashboard/components/GraphCanvasV2/layers/display-panel-layer';
import EditorDropdownLayer from 'dashboard/components/GraphCanvasV2/layers/editor-dropdown-layer';
import HoverCardLayer from 'dashboard/components/GraphCanvasV2/layers/hover-card-layer';
import { Layer } from 'dashboard/components/GraphCanvasV2/layers/layer';
import QueryEditorLayer from 'dashboard/components/GraphCanvasV2/layers/query-editor-layer';
import ReactModalsLayer from 'dashboard/components/GraphCanvasV2/layers/react-modals-layer';
import SelectionBoxLayer from 'dashboard/components/GraphCanvasV2/layers/selection-box-layer';
import WindowLayer from 'dashboard/components/GraphCanvasV2/layers/window-layer';
import { GraphExplorer } from 'dashboard/models/graph-explorer';

/**
 * LayerManager
 *
 * Constructed to help an event figure out what targets it needs to go to.
 */
export default class Layers implements Iterable<Layer> {
  protected layers: Layer[];

  constructor(
    g6Wrapper: G6Wrapper,
    graphExplorer: GraphExplorer,
    x: number,
    y: number,
    canvasX: number,
    canvasY: number,
    canvasBBox: { top: number; right: number; bottom: number; left: number },
  ) {
    this.layers = [
      new ReactModalsLayer(g6Wrapper, graphExplorer, x, y, canvasX, canvasY, canvasBBox),
      new QueryEditorLayer(g6Wrapper, graphExplorer, x, y, canvasX, canvasY, canvasBBox),
      new EditorDropdownLayer(g6Wrapper, graphExplorer, x, y, canvasX, canvasY, canvasBBox),
      new DisplayPanelLayer(g6Wrapper, graphExplorer, x, y, canvasX, canvasY, canvasBBox),
      new HoverCardLayer(g6Wrapper, graphExplorer, x, y, canvasX, canvasY, canvasBBox),
      new ActionBarLayer(g6Wrapper, graphExplorer, x, y, canvasX, canvasY, canvasBBox),
      new CanvasNodeLayer(g6Wrapper, graphExplorer, x, y, canvasX, canvasY, canvasBBox),
      new SelectionBoxLayer(g6Wrapper, graphExplorer, x, y, canvasX, canvasY, canvasBBox),
      new CanvasEdgeLayer(g6Wrapper, graphExplorer, x, y, canvasX, canvasY, canvasBBox),
      new CanvasLayer(g6Wrapper, graphExplorer, x, y, canvasX, canvasY, canvasBBox),
      new WindowLayer(g6Wrapper, graphExplorer, x, y, canvasX, canvasY, canvasBBox),
    ];
  }

  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  public [Symbol.iterator]() {
    const layers = this.layers;

    return {
      next: function () {
        const layer = layers.shift();
        return {
          value: layer,
          done: layer == null,
        };
      }.bind(this),
    };
  }
}
